import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncGetInvoiceNum = createAsyncThunk(
    "/fetchAsyncGetInvoiceNum",
    async (data) => {
      try {
        let url = `${API_URL}/sales-invoice/getInvoiceNum/${data.moduleId}`;
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
);

export const fetchAsyncSendRequestForApproval = createAsyncThunk(
  "/fetchAsyncSendRequestForApproval",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/send-request/${data.moduleId}`;
      const response = await axiosInstance.post(url, data?.formData);
     
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetAllSalesInvoice = createAsyncThunk(
  "/fetchAsyncGetAllSalesInvoice",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/get/${data.moduleId}/${data.moduleType}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncApproveInvoiceAmount = createAsyncThunk(
  "/fetchAsyncApproveInvoiceAmount",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/approve/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.put(url, data?.formData);
     
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncRejectInvoiceAmount = createAsyncThunk(
  "/fetchAsyncRejectInvoiceAmount",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/reject/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.put(url, data?.formData);
     
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncUpdateInvoiceData = createAsyncThunk(
  "/fetchAsyncUpdateInvoiceData",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/update/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.put(url, data?.formData);
     
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);



export const fetchAsyncSearchInvoiceData = createAsyncThunk(
  "/fetchAsyncSearchInvoiceData",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/search/${data?.moduleId}`;
      const params = new URLSearchParams();
      if (data.value) params.append('search', data.value);
      if (data.startDate) params.append('startDate', data.startDate);
      if (data.endDate) params.append('endDate', data.endDate);
      if (data.currency) params.append('currency', data.currency);

      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncReSendRequestForApproval = createAsyncThunk(
  "/fetchAsyncReSendRequestForApproval",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/re-send-request/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.put(url, data.formData);

      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncDeleteRefundItem = createAsyncThunk(
  "/fetchAsyncDeleteRefundItem",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/delete-refund-item/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.post( url,{listIndex:data?.listIndex });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncDeleteInvoiceOrder = createAsyncThunk(
  "/fetchAsyncDeleteInvoiceOrder",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/delete/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncHardDeleteInvoiceOrder = createAsyncThunk(
  "/fetchAsyncHardDeleteInvoiceOrder",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/hard-delete/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncUploadInvoicePurchase = createAsyncThunk(
  "/fetchAsyncUploadInvoicePurchase",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/upload-invoice/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.post(url, data.formData);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncDeleteInvoicePurchasePdf = createAsyncThunk(
  "/fetchAsyncDeleteInvoicePurchasePdf",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/delete-pdf/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.post(url,{ key: data.key,spId:data?.spId });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncAddInvoicePurchaseRemarks = createAsyncThunk(
  "/fetchAsyncAddInvoicePurchaseRemarks",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/purchase-remark/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.put(url, data.remarkData);

      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncSalesInvoiceXlsxData = createAsyncThunk(
  "/fetchAsyncSalesInvoiceXlsxData",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/xlsx/${data?.moduleId}`;
      if (data?.role && data.startDate && data.endDate) {
        url = url + `?role=${data.role}&startDate=${data.startDate}&endDate=${data.endDate}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncGetInvoiceBarChartData = createAsyncThunk(
  "/fetchAsyncGetInvoiceBarChartData",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/bar-chart-data/${data?.moduleId}`;
      const response = await axiosInstance.post(url,data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Token Expire Please Login again!");
      } else {
        throw new Error(error.response.data.message);
      }
    }
  }
);

export const fetchAsyncCheckInvoiceExist = createAsyncThunk(
  "/fetchAsyncCheckInvoiceExist",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/inv-exist/${data.moduleId}/${data.invNo}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncCheckProformaExist = createAsyncThunk(
  "/fetchAsyncCheckProformaExist",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/pfi-exist/${data.moduleId}/${data.invNo}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncGetPFINum = createAsyncThunk(
  "/fetchAsyncGetPFINum",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/getPfiNum/${data.moduleId}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncConvertIntoInvoice = createAsyncThunk(
  "/fetchAsyncConvertIntoInvoice",
  async (data) => {
    try {
      let url = `${API_URL}/sales-invoice/convert-invoice/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.put(url);
     
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
const AllSalesInvoiceSlice = createSlice({
  name: "invoiceData",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncGetAllSalesInvoice.pending]: (state) => {},
    [fetchAsyncGetAllSalesInvoice.fulfilled]: (state, { payload }) => {
      return payload;
    },
    [fetchAsyncSearchInvoiceData.pending]: (state) => {},
    [fetchAsyncSearchInvoiceData.fulfilled]: (state, { payload }) => {
      return payload;
    },
   
  },
});

export const getAllSalesInvoice = (state) => state.invoiceData;

export default AllSalesInvoiceSlice.reducer;